import React, { FC } from 'react'
import IconSVG, { IconSVGProps } from '../IconSVG'

const IconDots: FC<IconSVGProps> = (props) => {
  return (
    <IconSVG boxSize="14px" aria-label="IconDots" {...props}>
      <svg height="100%" viewBox="0 0 14 14" fill="currentColor">
        <g transform="translate(.25 .25)">
          <circle cx="1.875" cy="6.5" r="1.875" />
          <circle cx="6.875" cy="6.5" r="1.875" />
          <circle cx="11.875" cy="6.5" r="1.875" />
        </g>
      </svg>
    </IconSVG>
  )
}

export default IconDots
